import React from 'react';
import { UsersIcon } from 'lucide-react';
const SPOTS_LEFT = 9;
const TOTAL_SPOTS = 200;
export function ScarcityBar() {
  const filled = Math.round((TOTAL_SPOTS - SPOTS_LEFT) / TOTAL_SPOTS * 100);
  return <div className="w-full rounded-xl border border-ember/30 bg-ember/[0.07] p-4" data-id="element-49" data-mp="2l3v2qogp2a6w">
      <div className="flex items-center gap-2" data-id="element-50" data-mp="2q3he0scypgd2">
        <UsersIcon className="h-4 w-4 shrink-0 text-ember" aria-hidden="true" data-id="element-51" data-mp="2q26ej4qjuurr" />
        <p className="text-[13px] font-bold uppercase leading-tight tracking-wide text-white sm:text-sm" data-id="element-52" data-mp="2b5yvw8usi1el">
          Only {SPOTS_LEFT} spots left at the launch price
        </p>
      </div>
      <div className="mt-3 h-3 w-full overflow-hidden rounded-full bg-ink-700" role="progressbar" aria-valuenow={filled} aria-valuemin={0} aria-valuemax={100} aria-label="Launch price spots claimed" data-id="element-53" data-mp="2273m6msje96j">
        <div className="h-full rounded-full bg-ember" style={{
        width: `${filled}%`
      }} data-id="element-54" data-mp="5ds1ilzqe6nj" />
      </div>
      <p className="mt-2 text-[11px] font-medium text-white/50 sm:text-xs" data-id="element-55" data-mp="33m3bd912zdfg">
        {TOTAL_SPOTS - SPOTS_LEFT} of {TOTAL_SPOTS} launch spots already claimed
      </p>
    </div>;
}